// Clear client-side snapshots before a deploy reload (session + in-memory module caches).

import { clearRosterSessionCache } from "../src/pages/private/members/rosterTools/utils/rosterSessionCache";
import { clearPersonalHubSessionCache } from "../src/pages/private/members/personalhub/tools/personalHubSessionCache";
import { clearDashboardCardCache } from "../src/pages/private/members/personalhub/dashboard/dashboardSessionCache";

const PERMISSIONS_CACHE_KEY = "security.permissions.cache.v3";

/** Drop app snapshots that can survive a soft navigation or stale permission rows. */
export function clearAppCachesBeforeReload() {
  try {
    clearRosterSessionCache();
  } catch (err) {
    console.warn("[clearAppCachesBeforeReload] roster cache:", err);
  }

  try {
    clearPersonalHubSessionCache();
  } catch (err) {
    console.warn("[clearAppCachesBeforeReload] personal hub cache:", err);
  }

  try {
    clearDashboardCardCache();
  } catch (err) {
    console.warn("[clearAppCachesBeforeReload] dashboard cache:", err);
  }

  try {
    sessionStorage.removeItem(PERMISSIONS_CACHE_KEY);
  } catch {
    // ignore
  }
}
